import { useEffect, useState } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function DepannageUrgent() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Dépannage Plomberie Chauffage Urgent Valence 26 | Intervention Rapide 7j/7 | Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Dépannage plomberie et chauffage urgent à Valence 7j/7. Fuite d\'eau, panne chaudière, canalisation bouchée : intervention rapide dans l\'agglomération valentinoise. Ion Certan, plombier chauffagiste disponible. Appelez le 07 60 70 54 75.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/depannage-urgent');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  const urgences = [
    {
      image: 'https://public.readdy.ai/ai/img_res/e19d2bdaef0e9d0b4e0248ad491e4384.jpg',
      badge: 'Très Urgent',
      title: 'Fuite d\'eau urgente',
      description: 'Intervention immédiate pour stopper les fuites d\'eau et limiter les dégâts. Robinetterie, canalisations, joints défectueux.',
      points: [
        'Arrêt de la fuite en urgence',
        'Limitation des dégâts des eaux',
        'Réparation provisoire ou définitive',
        'Intervention rapide'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=emergency%20heating%20system%20repair%20professional%20technician%20fixing%20broken%20boiler%20winter%20cold%20urgent%20intervention%20tools%20pressure%20gauge%20clean%20white%20background%20realistic%20detailed%20high%20quality%20bright%20lighting%20professional%20photography&width=600&height=400&seq=urgence-panne-chauffage-valence-2025&orientation=landscape',
      badge: 'Prioritaire',
      title: 'Panne de chauffage',
      description: 'Dépannage rapide de votre chaudière, pompe à chaleur ou radiateurs. Rétablissement du confort thermique en urgence.',
      points: [
        'Diagnostic rapide de la panne',
        'Réparation chaudière gaz/fioul',
        'Dépannage pompe à chaleur',
        'Priorité en période de froid'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=emergency%20drain%20unclogging%20professional%20plumber%20using%20professional%20equipment%20to%20clear%20blocked%20pipe%20toilet%20sink%20urgent%20intervention%20tools%20clean%20white%20background%20realistic%20detailed%20high%20quality%20bright%20lighting%20professional%20photography&width=600&height=400&seq=urgence-debouchage-valence-2025&orientation=landscape',
      badge: 'Intervention Rapide',
      title: 'Canalisation bouchée',
      description: 'Débouchage professionnel de WC, lavabo, douche, évier. Matériel haute pression pour éliminer tous les bouchons.',
      points: [
        'Débouchage WC, lavabo, douche',
        'Furet électrique professionnel',
        'Déboucheur haute pression',
        'Inspection caméra si nécessaire'
      ]
    }
  ];

  const avantages = [
    {
      icon: 'ri-time-line',
      title: 'Intervention rapide',
      description: 'Déplacement sur Valence et agglomération pour limiter les dégâts'
    },
    {
      icon: 'ri-phone-line',
      title: 'Disponible 7j/7',
      description: 'Joignable tous les jours, week-ends et jours fériés pour vos urgences'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Équipement complet',
      description: 'Outillage professionnel embarqué pour intervenir immédiatement'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Devis transparent',
      description: 'Devis communiqué avant le début des travaux'
    }
  ];

  const marques = [
    { name: 'Saunier Duval', rating: 5 },
    { name: 'Viessmann', rating: 5 },
    { name: 'De Dietrich', rating: 5 },
    { name: 'Atlantic', rating: 5 },
    { name: 'Grohe', rating: 5 },
    { name: 'Geberit', rating: 5 }
  ];

  const temoignages = [
    {
      name: 'Valérie N.',
      ville: 'Valence',
      note: 5,
      texte: 'Fuite d\'eau importante un dimanche matin, Ion est intervenu en moins de 2h ! Professionnel, efficace et tarif honnête. Je recommande vivement pour les urgences.'
    },
    {
      name: 'Sébastien L.',
      ville: 'Bourg-lès-Valence',
      note: 5,
      texte: 'Panne de chaudière en plein hiver avec 2 enfants à la maison. Ion a diagnostiqué et réparé le problème rapidement. Un vrai professionnel disponible et réactif.'
    },
    {
      name: 'Patricia F.',
      ville: 'Guilherand-Granges',
      note: 5,
      texte: 'WC bouchés un vendredi soir, situation très gênante. Ion est venu en urgence et a résolu le problème en 30 minutes. Merci pour votre réactivité !'
    }
  ];

  const faq = [
    {
      question: 'Intervenez-vous en urgence le week-end et les jours fériés à Valence ?',
      answer: 'Oui, je suis disponible 7 jours sur 7 pour les dépannages urgents à Valence et dans l\'agglomération valentinoise. En cas de fuite d\'eau importante, panne de chauffage en hiver ou tout autre problème nécessitant une intervention immédiate, vous pouvez me joindre au 07 60 70 54 75. Je m\'efforce d\'intervenir le plus rapidement possible selon ma disponibilité et la localisation.'
    },
    {
      question: 'Quel est le tarif d\'un dépannage plomberie urgent à Valence ?',
      answer: 'Le tarif d\'un dépannage urgent dépend de plusieurs facteurs : nature de la panne, heure d\'intervention, pièces à remplacer, temps d\'intervention. Je vous communique systématiquement un devis avant de commencer les travaux. Tarifs transparents et honnêtes garantis.'
    },
    {
      question: 'Comment stopper une fuite d\'eau en attendant le plombier ?',
      answer: 'En cas de fuite d\'eau urgente à Valence, voici les gestes à faire en attendant mon arrivée : 1) Coupez l\'arrivée d\'eau générale (robinet principal, souvent près du compteur), 2) Coupez l\'électricité si l\'eau approche des prises ou du tableau électrique, 3) Placez des serpillières et bassines pour limiter les dégâts, 4) Prenez des photos pour votre assurance, 5) Appelez-moi immédiatement au 07 60 70 54 75. N\'essayez pas de réparer vous-même, vous pourriez aggraver la situation.'
    },
    {
      question: 'Que faire si ma chaudière tombe en panne en plein hiver ?',
      answer: 'En cas de panne de chaudière en hiver à Valence, contactez-moi rapidement au 07 60 70 54 75. En attendant mon intervention : vérifiez que le disjoncteur n\'a pas sauté, contrôlez la pression d\'eau de la chaudière (doit être entre 1 et 1,5 bar), vérifiez que le thermostat est bien réglé. Si vous avez un chauffage d\'appoint (radiateur électrique), utilisez-le dans les pièces principales. J\'interviens en priorité pour les pannes de chauffage en période de grand froid, surtout si vous avez des enfants ou personnes âgées.'
    },
    {
      question: 'Intervenez-vous pour déboucher les canalisations à Bourg-lès-Valence ?',
      answer: 'Oui, j\'interviens pour tous les débouchages urgents à Bourg-lès-Valence, Guilherand-Granges, Portes-lès-Valence et dans toute l\'agglomération valentinoise. WC bouchés, lavabo qui ne s\'écoule plus, douche engorgée, évier obstrué - je dispose du matériel professionnel adapté (furet électrique, déboucheur haute pression) pour venir à bout de tous les bouchons. Intervention rapide pour limiter la gêne et les risques de débordement.'
    },
    {
      question: 'Proposez-vous un contrat d\'entretien pour éviter les pannes ?',
      answer: 'Oui, je propose des contrats d\'entretien annuel pour votre chaudière, pompe à chaleur et climatisation à Valence. Un entretien régulier permet de prévenir 80% des pannes, d\'optimiser les performances de vos équipements, de réduire votre consommation d\'énergie et de prolonger leur durée de vie. L\'entretien annuel de la chaudière est d\'ailleurs obligatoire. Avec un contrat d\'entretien, vous bénéficiez d\'un tarif préférentiel en cas de dépannage et d\'une intervention prioritaire.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section avec image de fond */}
      <section className="relative pt-20 sm:pt-32 pb-12 sm:pb-24 min-h-[500px] sm:min-h-[90vh] flex items-center">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=emergency%20plumbing%20service%20professional%20plumber%20van%20arriving%20urgent%20call%20red%20orange%20dramatic%20lighting%20tools%20equipment%20ready%20intervention%20fast%20response%20realistic%20detailed%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-depannage-urgent-valence-2025&orientation=landscape"
            alt="Dépannage urgent plomberie chauffage Valence"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-red-900/85 via-orange-900/80 to-red-800/85"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-red-600 rounded-full mb-4 sm:mb-6">
              <span className="text-xs sm:text-sm font-bold text-white flex items-center whitespace-nowrap">
                <i className="ri-alarm-warning-line mr-2"></i>
                Disponible 7j/7 - Intervention Rapide
              </span>
            </div>
            
            <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Dépannage Plomberie et Chauffage Urgent à Valence
            </h1>
            
            <p className="text-base sm:text-xl text-orange-50 mb-6 sm:mb-8 leading-relaxed">
              Fuite d'eau, panne de chauffage, canalisation bouchée ? Plombier chauffagiste disponible 7j/7 à Valence. Intervention rapide pour tous vos dépannages urgents dans l'agglomération valentinoise.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 mb-6 sm:mb-10">
              <a
                href="tel:+33760705475"
                className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-5 bg-red-600 text-white font-bold text-base sm:text-lg rounded-lg hover:bg-red-700 transition-colors shadow-2xl whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
                Urgence : 07 60 70 54 75
              </a>
              <a
                href="mailto:ioncertanpro@gmail.com"
                className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-colors border-2 border-white/30 whitespace-nowrap text-sm sm:text-base"
              >
                <i className="ri-mail-line mr-2"></i>
                Email : ioncertanpro@gmail.com
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-time-line text-xl sm:text-2xl text-orange-300 mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white whitespace-nowrap">Intervention rapide</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-calendar-check-line text-xl sm:text-2xl text-orange-300 mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white whitespace-nowrap">Disponible 7j/7</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-file-list-3-line text-xl sm:text-2xl text-orange-300 mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white whitespace-nowrap">Devis transparent</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <div className="flex items-center text-xs sm:text-sm text-gray-600">
            <a href="/" className="hover:text-orange-600 transition-colors">Accueil</a>
            <i className="ri-arrow-right-s-line mx-1 sm:mx-2"></i>
            <span className="text-gray-900 font-semibold">Dépannage Urgent</span>
          </div>
        </div>
      </div>

      {/* Types d'urgences */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Nos Interventions d'Urgence à Valence
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Plombier chauffagiste disponible 7j/7 pour tous vos dépannages urgents dans l'agglomération valentinoise
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {urgences.map((urgence, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-2xl transition-shadow">
                <div className="relative h-48 sm:h-64 w-full">
                  <img
                    src={urgence.image}
                    alt={urgence.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 sm:top-4 right-3 sm:right-4">
                    <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-red-600 text-white text-xs font-bold rounded-full whitespace-nowrap">
                      {urgence.badge}
                    </span>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{urgence.title}</h3>
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 leading-relaxed">{urgence.description}</p>
                  <ul className="space-y-1.5 sm:space-y-2">
                    {urgence.points.map((point, idx) => (
                      <li key={idx} className="flex items-start text-xs sm:text-sm text-gray-700">
                        <i className="ri-check-line text-orange-600 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-orange-50 via-white to-red-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Pourquoi Faire Appel à un Plombier Local pour Vos Urgences ?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Artisan plombier chauffagiste basé à Valence, je vous garantis réactivité et professionnalisme
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {avantages.map((avantage, index) => (
              <div key={index} className="text-center bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer">
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-orange-600 to-red-600 rounded-xl mx-auto mb-3 sm:mb-4">
                  <i className={`${avantage.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">{avantage.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus Intervention */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Comment se Déroule une Intervention d'Urgence ?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Un processus clair et rapide pour résoudre votre problème de plomberie ou chauffage à Valence
            </p>
          </div>

          <div className="relative">
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-orange-200 via-red-200 to-orange-200 transform -translate-y-1/2" style={{ top: '80px' }}></div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
              <div className="relative">
                <div className="bg-gradient-to-br from-orange-50 to-white p-6 sm:p-8 rounded-xl border-2 border-orange-200 hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-orange-600 to-red-600 rounded-full mb-3 sm:mb-4 mx-auto shadow-lg">
                    <span className="text-xl sm:text-2xl font-bold text-white">1</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 text-center">Votre appel</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed text-center">
                    Vous me contactez au 07 60 70 54 75 et décrivez votre problème urgent
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-red-50 to-white p-6 sm:p-8 rounded-xl border-2 border-red-200 hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-full mb-3 sm:mb-4 mx-auto shadow-lg">
                    <span className="text-xl sm:text-2xl font-bold text-white">2</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 text-center">Diagnostic téléphonique</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed text-center">
                    J'évalue la situation et vous donne les premiers conseils d'urgence
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-orange-50 to-white p-6 sm:p-8 rounded-xl border-2 border-orange-200 hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-orange-600 to-red-600 rounded-full mb-3 sm:mb-4 mx-auto shadow-lg">
                    <span className="text-xl sm:text-2xl font-bold text-white">3</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 text-center">Déplacement rapide</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed text-center">
                    Je me déplace rapidement avec tout le matériel nécessaire
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-red-50 to-white p-6 sm:p-8 rounded-xl border-2 border-red-200 hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-full mb-3 sm:mb-4 mx-auto shadow-lg">
                    <span className="text-xl sm:text-2xl font-bold text-white">4</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 text-center">Réparation</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed text-center">
                    Je répare la panne et vérifie le bon fonctionnement de l'installation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Zone Intervention */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Zones d'Intervention Urgente
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto mb-6 sm:mb-8">
              Intervention rapide pour tous vos dépannages plomberie et chauffage dans l'agglomération valentinoise
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {['Valence', 'Bourg-lès-Valence', 'Guilherand-Granges', 'Portes-lès-Valence', 'Saint-Péray', 'Soyons', 'Étoile-sur-Rhône', 'Montélier'].map((ville, index) => (
              <div key={index} className="flex items-center justify-center bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md hover:border-orange-300 transition-all">
                <i className="ri-map-pin-line text-orange-600 mr-2"></i>
                <span className="font-semibold text-gray-800 text-sm">{ville}</span>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-gray-600 mb-4">Votre commune n'est pas dans la liste ?</p>
            <a
              href="tel:+33760705475"
              className="inline-flex items-center px-6 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Contactez-moi au 07 60 70 54 75
            </a>
          </div>
        </div>
      </section>

      {/* Marques dépannées */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Marques Dépannées
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Intervention sur toutes les marques de chaudières, pompes à chaleur et équipements sanitaires
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
            {marques.map((marque, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-4 sm:p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow text-center">
                <h3 className="font-bold text-gray-900 mb-1 sm:mb-2 text-xs sm:text-sm">{marque.name}</h3>
                <div className="flex justify-center gap-0.5 sm:gap-1">
                  {[...Array(marque.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-500 text-xs"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contenu SEO */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-orange-50 via-white to-red-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Dépannage Plomberie et Chauffage Urgent à Valence : Intervention Rapide 7j/7
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Face à une urgence de plomberie ou de chauffage à Valence, chaque minute compte. Fuite d'eau importante, panne de chaudière en plein hiver, canalisation bouchée qui déborde - ces situations nécessitent l'intervention rapide d'un plombier chauffagiste professionnel. Basé à Valence, je suis disponible 7 jours sur 7 pour tous vos dépannages urgents dans l'agglomération valentinoise.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Les Urgences Plomberie les Plus Fréquentes à Valence
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les urgences de plomberie peuvent survenir à tout moment et nécessitent une intervention immédiate pour limiter les dégâts. Les fuites d'eau sont parmi les problèmes les plus urgents : robinetterie défectueuse, canalisation percée, joint de chasse d'eau usé, tuyau éclaté par le gel. Une fuite non traitée peut causer des dégâts des eaux importants dans votre logement à Valence, endommager vos murs, plafonds et sols.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              Les canalisations bouchées constituent également une urgence fréquente : WC obstrués, lavabo qui ne s'écoule plus, douche engorgée, évier bouché. Ces situations peuvent rapidement dégénérer en débordement et nécessitent l'utilisation de matériel professionnel (furet électrique, déboucheur haute pression) pour éliminer efficacement le bouchon.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Dépannage Chauffage Urgent : Rétablir Votre Confort Rapidement
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Une panne de chauffage en plein hiver à Valence est une urgence absolue, particulièrement si vous avez des enfants ou des personnes âgées à la maison. Les pannes de chaudière peuvent avoir diverses origines : problème de pression, panne électrique, circulateur défectueux, vase d'expansion HS, brûleur encrassé. J'interviens rapidement pour diagnostiquer la panne et effectuer la réparation nécessaire.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              Les pompes à chaleur peuvent également tomber en panne : manque de gaz réfrigérant, compresseur défaillant, carte électronique HS, givre sur l'unité extérieure. Mon expertise me permet d'intervenir sur tous types d'équipements de chauffage pour rétablir rapidement votre confort thermique à Valence.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Intervention Rapide sur Valence et Agglomération
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              En tant que plombier chauffagiste local basé à Valence, je peux intervenir rapidement sur l'ensemble de l'agglomération valentinoise : Valence, Bourg-lès-Valence, Guilherand-Granges, Portes-lès-Valence, Saint-Péray, Soyons. Ma proximité me permet de me déplacer rapidement avec tout le matériel nécessaire pour résoudre votre problème urgent. Mon véhicule est équipé d'un stock de pièces détachées courantes pour pouvoir effectuer la réparation immédiatement dans la plupart des cas.
            </p>
          </article>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Ils M'ont Fait Confiance pour Leurs Urgences
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Témoignages de clients satisfaits de mes interventions d'urgence à Valence
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {temoignages.map((temoignage, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-5 sm:p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-red-600 rounded-full mr-3 sm:mr-4">
                    <span className="text-white font-bold text-base sm:text-lg">{temoignage.name.charAt(0)}</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-sm sm:text-base">{temoignage.name}</h3>
                    <p className="text-xs sm:text-sm text-gray-600">{temoignage.ville}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                  {[...Array(temoignage.note)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-500 text-sm sm:text-base"></i>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-700 leading-relaxed italic">"{temoignage.texte}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Questions Fréquentes sur le Dépannage Urgent
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              Toutes les réponses à vos questions sur les interventions d'urgence à Valence
            </p>
          </div>

          <div className="space-y-4">
            {faq.map((item, index) => (
              <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
                <button
                  onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                  className="w-full text-left p-6 flex items-start justify-between hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start flex-1">
                    <i className="ri-question-line text-orange-600 mr-3 mt-1 flex-shrink-0 text-xl"></i>
                    <span className="font-bold text-gray-900 pr-4">{item.question}</span>
                  </div>
                  <i className={`ri-arrow-${openFaqIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 flex-shrink-0`}></i>
                </button>
                {openFaqIndex === index && (
                  <div className="px-6 pb-6">
                    <p className="text-sm text-gray-600 leading-relaxed ml-8">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section avec image de fond */}
      <section className="relative py-16 sm:py-24">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=emergency%20call%20plumber%20professional%20service%20van%20tools%20equipment%20urgent%20response%20red%20orange%20dramatic%20lighting%20phone%20contact%20ready%20intervention%20realistic%20detailed%20high%20quality%20professional%20photography&width=1920&height=600&seq=cta-depannage-urgent-valence-2025&orientation=landscape"
            alt="Contactez-nous pour un dépannage urgent"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-red-900/90 via-orange-900/85 to-red-800/90"></div>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-4 sm:mb-6">
            <i className="ri-alarm-warning-line text-4xl sm:text-6xl text-white mb-3 sm:mb-4"></i>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6">
            Besoin d'un Dépannage Urgent à Valence ?
          </h2>
          <p className="text-base sm:text-lg text-orange-50 mb-6 sm:mb-8 leading-relaxed">
            Disponible 7j/7 pour tous vos dépannages plomberie et chauffage. Intervention rapide dans l'agglomération valentinoise.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center">
            <a
              href="tel:+33760705475"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-red-600 font-bold text-base sm:text-lg rounded-lg hover:bg-gray-100 transition-colors shadow-2xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2 text-lg sm:text-xl"></i>
              Urgence : 07 60 70 54 75
            </a>
            <a
              href="mailto:ioncertanpro@gmail.com"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-red-800 text-white font-semibold rounded-lg hover:bg-red-900 transition-colors shadow-lg whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-mail-line mr-2"></i>
              Email : ioncertanpro@gmail.com
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}